import riaImg from "../../../assets/images/service/ria.jpeg";
import {
  Zap,
  Search,
  AlertCircle,
  Clock,
  ClipboardCheck,
  ShieldCheck,
  TrendingUp,
  Maximize,
  UserCheck,
  Activity,
  FileText
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function RapidInspectionAssessment() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row align-items-center gy-5">
                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    RIA: <span className="green">Rapid Inspection & Assessments</span>
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise offers high-speed technical audits and site evaluations 
                    designed to provide immediate clarity on infrastructure health, 
                    safety compliance, and operational efficiency.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>48-hour "Snapshot" audits for electrical & civil assets</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Identification of critical "Point of Failure" risks</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Quick-glance regulatory & safety gap analysis</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={riaImg}
                      alt="Rapid Inspection & Assessment"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-bolt"></i> Real-Time Technical Insights
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">Agile Diagnostics for Critical Infrastructure</h3>
                    <p className="mb-3">
                      When projects are in motion or assets are operational, you don't always have weeks for a full-scale audit. Our **Rapid Inspection & Assessment (RIA)** framework is designed for the fast-paced requirements of MNC vendors and high-load industrial sites. We deploy specialized teams to conduct non-invasive testing and visual inspections that catch issues—like thermal hotspots in panels or land encroachment—before they escalate.
                    </p>
                    <p className="mb-3">
                      For your 4.5 MW substation or Jamnagar property, RIA provides a vital "Health Certificate" that can be used for insurance renewals, safety certifications, or internal management reviews.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Activity size={22} />
                        </span>
                        <span>Thermal Imaging & Electrical Load Stress Testing</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Search size={22} />
                        </span>
                        <span>Rapid Site Condition & Encroachment Scouting</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <AlertCircle size={22} />
                        </span>
                        <span>Immediate Hazard Identification & Remediation Roadmaps</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileText size={22} />
                        </span>
                        <span>Executive Summary Reports with Actionable Scores</span>
                      </li>
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">Speed Meets Technical Excellence</h4>
                    <p className="mb-6">
                      The RIA methodology minimizes downtime while maximizing situational awareness, giving you the data needed for quick executive decisions.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <Clock size={22} />
                        </span>
                        <span>Drastically reduced assessment lead times</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Proactive prevention of catastrophic equipment failure</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ClipboardCheck size={22} />
                        </span>
                        <span>Simplified compliance for MNC vendor audits</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Data-backed justification for maintenance budgets</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Scalable assessment framework for multi-site portfolios</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Peace of mind through expert third-party validation</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}